import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'

const MoveDeal = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      funnels: 'Funnels',
    },
  })

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.value)
      : selectedOptions
        ? [selectedOptions.value]
        : []

    changeValues(selectedValues, 'funnels')
  }

  return (
    <FormField>
      <FormLabel isRequired>{translate.funnels}</FormLabel>
      <SelectCustom
        placeholder={translate.funnels}
        valueID={modalValue.funnels || []}
        onChange={handleSelectChange}
        apiLinkCRM={'integration/funnels'}
        error={check('funnels')}
        isMulti
      />
    </FormField>
  )
}

export default observer(MoveDeal)
